/**
 * Do not edit directly, this file was auto-generated.
 * Generated on Thu, 26 Jun 2025 13:37:26 GMT
 */
export const theme = {
    "color": {
        "text": {
            "default": "#161617",
            "subtle": "#696a6f",
            "error": "#a20121",
            "warning": "#664900",
            "disabled": "#696a6f",
            "success": "#15884f",
            "brandPrimary": "#eb0055",
            "brandPrimaryHover": "#cb0659",
            "brandSecondary": "#320096",
            "brandSecondaryHover": "#25026c",
            "inverted": "#ffffff",
            "lockedInverted": "#ffffff",
            "locked": "#161617"
        },
        "border": {
            "default": "#90949d",
            "subtle": "#cbcdd2",
            "disabled": "#cbcdd2",
            "error": "#a20121",
            "success": "#15884f",
            "selected": "#161617",
            "focused": "#161617",
            "brandPrimary": "#eb0055",
            "brandPrimaryHover": "#cb0659",
            "brandSecondary": "#320096",
            "brandSecondaryHover": "#25026c",
            "inverted": "#ffffff",
            "decorative01": "#d63d00",
            "decorative02": "#14a0be",
            "decorative03": "#0e8474",
            "decorative04": "#320096",
            "decorative05": "#eb0055"
        },
        "outline": {
            "default": "#161617",
            "error": "#a20121",
            "inverted": "#ffffff"
        },
        "background": {
            "default": "#ffffff",
            "subtle": "#f1f1f4",
            "disabled": "#f1f1f4",
            "error": "#f8b2c0",
            "success": "#91e1b5",
            "warning": "#f9df81",
            "info": "#f3edff",
            "hover": "#f1f1f4",
            "brandPrimary": "#eb0055",
            "brandPrimaryHover": "#cb0659",
            "brandPrimarySelected": "#ffe0ea",
            "brandSecondary": "#320096",
            "brandSecondaryHover": "#25026c",
            "locked": "#ffffff",
            "lockedInverted": "#161617",
            "lockedBrandPrimary": "#eb0055",
            "lockedBrandSecondary": "#320096",
            "inverted": "#161617",
            "decorative01": "#ffeae2",
            "decorative02": "#9be3f3",
            "decorative03": "#94f0d6",
            "decorative04": "#c1a3ff",
            "decorative05": "#ffa5c0",
            "headline": "#f3edff",
            "bookclub": "#dcf3f8",
            "cineclub": "#ffe0ea",
            "overlay": "#24242429"
        },
        "icon": {
            "default": "#161617",
            "disabled": "#696a6f",
            "subtle": "#696a6f",
            "locked": "#161617",
            "info": "#320096",
            "error": "#a20121",
            "success": "#15884f",
            "warning": "#e1a605",
            "brandPrimary": "#eb0055",
            "brandPrimaryHover": "#cb0659",
            "brandSecondary": "#320096",
            "brandSecondaryHover": "#25026c",
            "inverted": "#ffffff",
            "lockedInverted": "#ffffff",
            "headline": "#6123df",
            "bookclub": "#14a0be",
            "cineclub": "#cb0659"
        }
    },
    "separator": {
        "color": {
            "default": "#90949d",
            "subtle": "#cbcdd2"
        }
    },
    "size": {
        "borderRadius": {
            "s": "0.25rem",
            "m": "0.5rem",
            "l": "1rem",
            "xl": "1.5rem",
            "xxl": "2rem",
            "pill": "62.4375rem"
        },
        "spacing": {
            "xxs": "0.125rem",
            "xs": "0.25rem",
            "s": "0.5rem",
            "m": "0.75rem",
            "l": "1rem",
            "xl": "1.5rem",
            "xxl": "2rem",
            "xxxl": "2.5rem",
            "xxxxl": "3rem"
        }
    },
    "typography": {
        "title1": {
            "fontFamily": "Montserrat-Bold",
            "fontSize": "1.75rem",
            "lineHeight": "2.8rem"
        },
        "title2": {
            "fontFamily": "Montserrat-Bold",
            "fontSize": "1.3125rem",
            "lineHeight": "2.1rem"
        },
        "title3": {
            "fontFamily": "Montserrat-Bold",
            "fontSize": "1.1875rem",
            "lineHeight": "1.9rem"
        },
        "title4": {
            "fontFamily": "Montserrat-Bold",
            "fontSize": "1.0625rem",
            "lineHeight": "1.7rem"
        },
        "body": {
            "fontFamily": "Montserrat-Medium",
            "fontSize": "1rem",
            "lineHeight": "1.6rem"
        },
        "bodyS": {
            "fontFamily": "Montserrat-Medium",
            "fontSize": "0.875rem",
            "lineHeight": "1.4rem"
        },
        "bodyXs": {
            "fontFamily": "Montserrat-Medium",
            "fontSize": "0.75rem",
            "lineHeight": "1.2rem"
        },
        "bodyAccent": {
            "fontFamily": "Montserrat-SemiBold",
            "fontSize": "1rem",
            "lineHeight": "1.6rem"
        },
        "bodyAccentS": {
            "fontFamily": "Montserrat-SemiBold",
            "fontSize": "0.875rem",
            "lineHeight": "1.4rem"
        },
        "bodyAccentXs": {
            "fontFamily": "Montserrat-SemiBold",
            "fontSize": "0.75rem",
            "lineHeight": "1.2rem"
        },
        "bodyItalic": {
            "fontFamily": "Montserrat-MediumItalic",
            "fontSize": "1rem",
            "lineHeight": "1.6rem"
        },
        "bodyItalicAccent": {
            "fontFamily": "Montserrat-SemiBoldItalic",
            "fontSize": "1rem",
            "lineHeight": "1.6rem"
        },
        "button": {
            "fontFamily": "Montserrat-Bold",
            "fontSize": "1rem",
            "lineHeight": "1.6rem"
        }
    }
};
//# sourceMappingURL=light.web.js.map